<template>
  <form :id="'frm-'+id" class="px-3" method="post" onsubmit="return false">
    <div :aria-labelledby="id+'-title'"
        :data-id="name"
        :id="id"
        :data-backdrop="'static'"
        :data-keyboard="'false'"
        aria-hidden="true"
        class="modal fade"
        role="dialog"
        tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header modal-body-scrolled">
            <h5 :id="id+'-title'" class="modal-title">{{ title }}</h5>
          </div>
          <div class="modal-body overflow-x-hidden">
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="first_name">Nombre: *
              </label>
              <input type="text"
                     id="first_name"
                     name="first_name"
                     class="form-control"
                     v-model="form.first_name"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="middle_name">Segundo nombre:
              </label>
              <input type="text"
                     id="middle_name"
                     name="middle_name"
                     class="form-control"
                     v-model="form.middle_name"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="last_name">Apellido paterno*:
              </label>
              <input type="text"
                     id="last_name"
                     name="last_name"
                     class="form-control"
                     v-model="form.last_name"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="family_name">Apellido materno: *
              </label>
              <input type="text"
                     id="family_name"
                     name="family_name"
                     class="form-control"
                     v-model="form.family_name"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="email">Email: *
              </label>
              <input type="email"
                     id="email"
                     name="email"
                     class="form-control"
                     v-model="form.email"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="curp">CURP:
              </label>
              <input type="text"
                     id="curp"
                     name="curp"
                     class="form-control"
                     v-model="form.curp"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="rfc">RFC:
              </label>
              <input type="text"
                     id="rfc"
                     name="rfc"
                     class="form-control"
                     v-model="form.rfc"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="external_institution_id">Centro / Institución: *
              </label>
              <select type="text"
                      id="external_institution_id"
                      name="external_institution_id"
                      class="form-control"
                      v-model="form.external_institution_id">
                  <option value="">Seleccione una opción</option>
                  <option v-for="option in externalInstitutions"
                          :key="option.id"
                          :value="option.id">
                    {{ option.title }}
                  </option>
              </select>
            </div>
            <div class="form-group external_institution_other_container collapse">
              <label class="d-block font-weight-normal"
                     for="external_institution_other">Especifique la institución: *
              </label>
              <input type="text"
                     id="external_institution_other"
                     name="external_institution_other"
                     class="form-control"
                     v-model="form.external_institution_other"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="expertise_area">Área de experiencia: *
              </label>
              <input type="text"
                     id="expertise_area"
                     name="expertise_area"
                     class="form-control"
                     v-model="form.expertise_area"/>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="marital_status_id">Estado civil: *
              </label>
              <select type="text"
                      id="marital_status_id"
                      name="marital_status_id"
                      class="form-control"
                      v-model="form.marital_status_id">
                  <option value="">Seleccione una opción</option>
                  <option v-for="option in maritalStatuses"
                          :key="option.id"
                          :value="option.id">
                    {{ option.title }}
                  </option>
              </select>
            </div>
            <div class="form-group">
              <label class="d-block font-weight-normal"
                     for="gender">Genero: *
              </label>
              <select type="text"
                      id="gender"
                      name="gender"
                      class="form-control"
                      v-model="form.gender">
                  <option value="">Seleccione una opción</option>
                  <option v-for="option in genders"
                          :key="option.id"
                          :value="option.value">
                    {{ option.title }}
                  </option>
              </select>
            </div>
          </div>
          <div class="modal-footer flex justify-content-end px-2 shadow-none">
            <button class="btn btn-danger ml-2"
                    type="button"
                    :disabled="loading"
                    @click="closeModal">
                Cancelar
            </button>
            <button class="btn btn-primary ml-2"
                    type="submit"
                    :disabled="loading">
                <span class="spinner-border text-white spinner-border-sm"
                      role="status"
                      v-if="loading">
                  <span class="sr-only">Guardando...</span>
                </span>   
                Registrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import { AlertManager } from '../utils/AlertManager'
  import { mapActions } from 'vuex'
  
  export default {
    name: 'RegisterExternalUserModal',
    components: {},
    props: {
      title: {
        default: 'Registro de coinvestigador externo',
      },
      id: {
        default: 'register-external-user-modal',
      },
      name: {
        default: 'register-external-users-modal',
      },
      selectedUsers: {
        type: Array,
        default: () => ([]),
      },
      externalInstitutions: {
        type: Array,
        default: null,
      },
      maritalStatuses: {
        type: Array,
        default: null,
      },
    },
    data () {
      return{
        loading: false,
        form: {
          first_name: '',
          middle_name: '',
          last_name: '',
          family_name: '',
          email: '',
          curp: '',
          rfc: '',
          external_institution_id: '',
          external_institution_other: '',
          expertise_area: '',
          marital_status_id: '',
          gender: '',
        },
        genders: [
          {
            value: 'masculino',
            title: 'Masculino',
          },
          {
            value: 'femenino',
            title: 'Femenino',
          },
          {
            value: 'no_especificado',
            title: 'No especificado',
          },
        ],
      }
    },
    methods: {
      ...mapActions({
        addPublicationExternalResearcher: 'users/addPublicationExternalResearcher',
      }),
      async registerExternalUser () {
        this.loading = true

        const response = await this.addPublicationExternalResearcher({
          user: this.form,
        })

        if (response.status === 'success') {
          this.$emit('user-registered', response.user)

          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)

          this.loading = false

          return
        }

        this.loading = false

        $(`#${this.id}`).modal('hide')

        this.clearModal()
      },
      closeModal () {
        $(`#${this.id}`).modal('hide')

        this.clearModal()
      },
      clearModal () {
        this.form = {
          first_name: '',
          middle_name: '',
          last_name: '',
          family_name: '',
          email: '',
          curp: '',
          rfc: '',
          external_institution_id: '',
          external_institution_other: '',
          expertise_area: '',
          marital_status_id: '',
          gender: '',
        }
      }
    },
    computed: {},
    mounted () {
      const vm = this

      $(`#frm-${vm.id}`).validate({
        ignore: [],
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          label.insertAfter(element)
          label.addClass('invalid-feedback')
        },
        rules: {
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          family_name: {
            required: {},
          },
          email: {
            required: true,
          },
          gender: {
            required: true,
          },
          curp:{},
          rfc:{},
          external_institution_id: {
            required: true,
          },
          external_institution_other: {
            required: function () {
              return parseInt($('#external_institution_id').val()) === 474
            },
          },
          expertise_area: {
            required: true,
          },
          marital_status_id: {
            required: true,
          },
        },
        messages: {
          first_name: {
            required: 'Este campo es requerido',
          },
          last_name: {
            required: 'Este campo es requerido',
          },
          family_name: {
            required: 'Este campo es requerido',
          },
          email: {
            required: 'Este campo es requerido',
          },
          gender: {
            required: 'Este campo es requerido',
          },
          curp:{},
          rfc:{},
          external_institution_id: {
            required: 'Este campo es requerido',
          },
          external_institution_other: {
            required: 'Este campo es requerido.',
          },
          expertise_area: {
            required: 'Este campo es requerido',
          },
          marital_status_id: {
            required: 'Este campo es requerido',
          },
        },
        submitHandler (form) {
          vm.registerExternalUser()
        },
      })

      if (parseInt($('#external_institution_id').val()) === 474) {
        $('.external_institution_other_container').removeClass('d-none').addClass('show')
      }

      $('#external_institution_id').on('change', function (e) {
        if (parseInt($(this).val()) === 474) {
          $('.external_institution_other_container').removeClass('d-none').addClass('show')
        }
        else {
          $('.external_institution_other_container').removeClass('show').addClass('d-none')
        }
      })
    },
  }
</script>
